// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__VyiDS","label":"Completed_label__11hZc"};